<template>
  <div class="control-select">
    <div class="control-select__trigger"
         :class="{ open: isOpen }"
         @click="toggleDropdown">
      <span>{{ selectedName }}</span>
      <i class="fa fa-chevron-down"></i>
    </div>
    <div v-if="isOpen" class="control-select__menu">
      <ul class="control-select__content">
        <li
            v-for="(option, index) in control || []"
            :key="index"
            @click="selectOption(option)"
            :class="{ 'selected': option.Value === value }"
        >
          {{ option.Name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import windowWidthMixin from '../../mixins/window-width';

export default {
  props: ['control', 'defaultValue', 'specification'],
  mixins: [windowWidthMixin],
  data() {
    return {
      isOpen: false,
      value: this.defaultValue,
    };
  },
  computed: {
    ...mapState({
      spec: (state) => state.listing.specification,
    }),
    defaultExists() {
      return (this.control || []).some((item) => item.Value === this.defaultValue);
    },
    selectedName() {
      const selectedOption = (this.control || []).find((item) => item.Value === this.value);
      return selectedOption ? selectedOption.Name : this.defaultValue;
    },
  },
  watch: {
    spec: {
      handler(value) {
        if (value[this.specification] !== '' && value[this.specification] !== null) {
          this.value = value[this.specification];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.value = option.Value;
      this.updateSpecification({
        key: this.specification,
        value: this.value,
        manualSearch: this.isSmallScreen
      });

      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    this.value = "Sort By";
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'listing/resetSpecification') {
        this.value = this.defaultValue;
      }
    });

    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.control-select {
  height: 62px;
  background: #FFFFFF;
  border-radius: 1rem;
  border: 2px solid #DDE0DC;
  position: relative;
  cursor: pointer;
  &__trigger {
    height: 100%;
    font-size: 1.125rem;
    font-weight: 700;
    padding: 0 1rem;
    display: flex;
    gap: .625rem;
    &.is-open {
      i {
        transform: rotate(180deg);
      }
    }
    i {
      margin: auto 0;
    }
    span {
      flex: 1;
      margin: auto 0;
      white-space: nowrap;
      overflow: hidden;
      line-height: 1;
    }
  }
  &__menu {
    background: #FFFFFF;
    border-radius: 1.5rem;
    padding: 1.5rem 0;
    box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.25);
    position: absolute;
    z-index: 99;
    top: 75px;

    &:before {
      content: "";
      z-index: -1;
      width: 2rem;
      height: 2rem;
      background: white;
      transform: rotate(45deg);
      position: absolute;
      top: -5px;
      left: calc(50% - 1rem);
    }
  }
  &__content {
    padding: 0;
    list-style: none;
    max-height: 250px;
    margin: 0;
    li {
      padding: .5rem 2rem;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      &.selected {
        background: #1D8958;
        color: #FFFFFF;
        &:hover {
          background: #1D8958;
        }
      }
      &:hover {
        background: #f0f0f0;
      }
    }
  }
}
</style>
